import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Autocomplete from "@mui/material/Autocomplete";
import { AlertContext } from "../../../../context/AlertContext";
import { ConfiguracionContext } from "../../../../context/ConfiguracionContext";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { Link, Redirect } from "react-router-dom";
import Spinner from "../../Spinner";
import { AuthContext } from "../../../../context/AuthContext";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import ButtonMui from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import hcOffcanvasNav from "hc-offcanvas-nav";
import $ from "jquery";
import { saveAs } from "file-saver";
import { Navigate, useNavigate } from "react-router-dom";
import Barra from "../../Barra";

export default function ConsumosMedicamentos(props) {
  const [globalFilter, setGlobalFilter] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const exportColumns = [
    { title: "ID", dataKey: "id" },
    { title: "SKU", dataKey: "sku" },
    { title: "Fecha", dataKey: "fecha" },
    { title: "Cantidad", dataKey: "cantidad" },
    { title: "Almacen", dataKey: "almacen" },
    { title: "Tipo", dataKey: "tipo" },
    { title: "Descripción", dataKey: "descripcion" },
  ];

  const [consumoMedicamento, guardarConsumoMedicamento] = useState(null);
  const [visible, setVisible] = useState(false);
  const [stockTotal, guardarStockTotal] = useState(null);

  const toast = useRef(null);
  let navigate = useNavigate();
  const acAlmacen = useRef(null);

  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const {
    statusAcceso,
    almacenes,
    almacen,
    medicamentos,
    consumosMedicamentos,
    stocksMedicamentos,
    movimientosMedicamentos,
    obtenerConsumosMedicamentos,
    obtenerAcceso,
    obtenerAlmacenes,
    guardarAlmacen,
    guardarConsumosMedicamentos,
    agregarConsumoMedicamento,
    obtenerMedicamentosSku,
    obtenerStocksMedicamentos,
    agregarMovimientoMedicamento,
    agregarReposicionMedicamentos,
  } = configuracionContext;

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({
        usuarioId: state.usuario.id,
        layout: "ConsumosMedicamentos",
      });
    }
    //obtenerMedicamentosSku({ todos: true });
    obtenerAlmacenes();
    obtenerStocksMedicamentos({ almacen: 1 });
  }, [state.id]);

  setTimeout(() => {
    if (statusAcceso === 400) {
      accesoDenegado();
    }
  }, 3000);

  const addClick = (e) => {
    //navigate(`/base/0`);
    setVisible(true);
    setSelectedRow(null);
    guardarConsumoMedicamento({
      descripcion: null,
    });
  };

  const exitClick = (e) => {
    navigate(`/`);
    var Nav = new hcOffcanvasNav("#main-nav", {
      disableAt: false,
      customToggle: ".toggle",
      levelSpacing: 40,
      navTitle: "Home",
      levelTitles: true,
      levelTitleAsBack: true,
      pushContent: "#container",
      labelClose: false,
      position: "left",
      levelOpen: "overlap",
    });
    Nav.open(3, 1);
  };

  const onHide = (e) => {
    setSelectedRow(null);
    setVisible(false);
  };

  const confirmarClick = (e) => {
    let date = new Date();
    let newDate = new Date(date);
    newDate.setHours(date.getHours() - 3);


    let movimientoMedicamento = [];
    for (var i = 0; i < consumosMedicamentos.length; i++) {
      if (Number(consumosMedicamentos[i].reponer) > 0) {
        movimientoMedicamento.push({
          id: null,
          sku: consumosMedicamentos[i].sku,
          fecha: newDate,
          cantidad: consumosMedicamentos[i].reponer,
          almacenId: almacen.id,
          tipo: "E",
          descripcion: almacen.nombre,
          servicio: null,
        });
      }
    }

    if (
      acAlmacen.current.getElementsByClassName(
        "MuiAutocomplete-clearIndicator",
      )[0]
    ) {
      acAlmacen.current
        .getElementsByClassName("MuiAutocomplete-clearIndicator")[0]
        .click();
    }

    if (movimientoMedicamento && movimientoMedicamento.length > 0) {
      agregarReposicionMedicamentos({ movimientoMedicamento, ultimoId: movimientosMedicamentos[0].id2 });
    } else {
      toast.current.show({
        severity: "info",
        summary: "Reposición",
        detail: `No hay medicamentos para reponer !.`,
        life: 3000,
      });
    }
  };

  const aceptarClick = (e) => {
    e.preventDefault();

    //Validar
    if (
      !consumoMedicamento ||
      consumoMedicamento === undefined ||
      consumoMedicamento === null ||
      consumoMedicamento === ""
    ) {
      mensajeAlerta(
        "Reposición de Medicamentos",
        "La cantidad es necesaria !.",
        "error",
      );
      return;
    }

    // Llamar al context
    if (selectedRow) {
      let index = consumosMedicamentos.findIndex(
        (item) => item.sku === selectedRow.sku,
      );
      consumosMedicamentos[index].reponer = Number(consumoMedicamento);

      onHide();
      //actualizarConsumoMedicamento({ consumoMedicamento });
    } else {
      //agregarConsumoMedicamento({ consumoMedicamento });
    }
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Accesos",
      "No tiene permiso para acceder a esta pantalla !.",
      "error",
    );
    exitClick();
    return;
  };

  const idTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">ID</span>
        {rowData.id}
      </Fragment>
    );
  };

  const skuTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">SKU</span>
        {rowData.sku}
      </Fragment>
    );
  };

  const nombreTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Nombre</span>
        {rowData.nombre}
      </Fragment>
    );
  };

  const fechaTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Fecha</span>
        {rowData.fecha}
      </Fragment>
    );
  };

  const almacenTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Almacen</span>
        {rowData.almacen}
      </Fragment>
    );
  };

  const cantidadTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Cantidad</span>
        {rowData.cantidad}
      </Fragment>
    );
  };

  const stockTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Stock</span>
        {rowData.stock}
      </Fragment>
    );
  };

  const reponerTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Reponer</span>
        {rowData.reponer}
      </Fragment>
    );
  };

  const tipoTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Tipo</span>
        {rowData.tipo}
      </Fragment>
    );
  };

  const descripcionTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Descripción</span>
        {rowData.descripcion}
      </Fragment>
    );
  };

  const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default(0, 0);
        doc.setFontSize(12);
        doc.text("Listado de Movimientos de Medicamentos", 60, 8);
        doc.autoTable(exportColumns, consumosMedicamentos);
        //doc.save("movimientosdemedicamentos.pdf");
        window.open(doc.output("bloburl"));
      });
    });
  };

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(consumosMedicamentos);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      saveAsExcelFile(excelBuffer, "movimientosdemedicamentos");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION,
      );
    });
  };

  const header = (
    <Fragment>
      <Grid item xs={12} md={4}>
        <Autocomplete
          id="almacen"
          ref={acAlmacen}
          fullWidth
          options={almacenes.filter((item) => item.id !== 1)}
          disablePortal
          getOptionLabel={(option) => option.nombre}
          renderInput={(params) => (
            <TextField {...params} label="Almacén" variant="standard" />
          )}
          //onKeyDown={handleEnter}
          onChange={(event, value) => {
            if (value) {
              obtenerConsumosMedicamentos({ almacen: value.id });
              guardarAlmacen({
                id: value.id,
                nombre: value.nombre,
              });
            } else {
              guardarConsumosMedicamentos(null);
              guardarAlmacen(null);
            }
          }}
        />
      </Grid>

      <div className="p-d-flex export-buttons" style={{ marginTop: "0.5em" }}>
        <Button
          type="button"
          icon="pi pi-file-excel"
          onClick={exportExcel}
          className="p-button-success p-mr-2"
          data-pr-tooltip="XLS"
        />
        <Button
          type="button"
          icon="pi pi-file-pdf"
          onClick={exportPdf}
          className="p-button-warning p-mr-2"
          data-pr-tooltip="PDF"
          style={{ marginRight: "1em" }}
        />
        <span
          style={{ marginLeft: "1em", marginRight: "1em" }}
          className="p-input-icon-left"
        >
          <i className="pi pi-search" />
          <InputText
            type="search"
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Buscar"
          />
        </span>
        <Tag
          value={
            movimientosMedicamentos && movimientosMedicamentos.length > 0
              ? "Consumos Medicamentos desde " +
                movimientosMedicamentos[0].fecha1 +
                " hasta " +
                movimientosMedicamentos[0].fecha2
              : "Consumos Medicamentos"
          }
        ></Tag>
      </div>
    </Fragment>
  );

  const renderHeader = () => {
    return (
      <div>
        <Tag
          value={
            selectedRow && stocksMedicamentos
              ? "Reposición de " +
                selectedRow.nombre +
                " - TOTAL EN STOCK: " +
                stockTotal
              : "Reposición de Medicamentos"
          }
        ></Tag>
      </div>
    );
  };

  const renderFooter = () => {
    return (
      <div>
        <ButtonMui
          onClick={aceptarClick}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        <ButtonMui
          onClick={onHide}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  //console.log(movimientosMedicamentos)

  return (
    <Fragment>
      <Barra />
      <Toast ref={toast} />
      {statusAcceso === 0 || statusAcceso === 400 ? <Spinner /> : null}
      {statusAcceso === 200 ? (
        <Fragment>
          {almacenes ? (
            <Fragment>
              <Grid id="dataTableBotones" item xs={12} sm={12} md={12}>
                <Button
                  icon="pi pi-plus"
                  tooltip="Agregar"
                  className="p-button-rounded p-button-help"
                  style={{ marginLeft: "0em" }}
                  onClick={addClick}
                />
                {/*
              <Button
                icon="pi pi-pencil"
                tooltip="Editar"
                className="p-button-rounded p-button-danger"
                style={{ marginLeft: "1em" }}
                onClick={editClick}
              />
              */}
                <Button
                  icon="pi pi-times"
                  tooltip="Cerrar"
                  className="p-button-rounded p-button-primary"
                  style={{ marginLeft: "1em" }}
                  onClick={exitClick}
                />

                <Button
                  label="Confirmar Reposición"
                  icon="pi pi-check"
                  severity="success"
                  disabled={
                    !consumosMedicamentos ||
                    (consumosMedicamentos && consumosMedicamentos.length === 0)
                  }
                  style={{ marginLeft: "1em" }}
                  onClick={confirmarClick}
                />

                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  style={{ align: "center", margin: "1em" }}
                />
                <div className="datatable-responsive-demo">
                  <div className="card">
                    <Tooltip
                      target=".export-buttons>button"
                      position="bottom"
                    />
                    <DataTable
                      value={consumosMedicamentos}
                      selection={selectedRow}
                      onSelectionChange={(e) => {
                        setSelectedRow(e.value);
                        guardarConsumoMedicamento(e.value.reponer);
                        let index2 = stocksMedicamentos.findIndex(
                          (item) => item.sku === e.value.sku,
                        );
                        guardarStockTotal(stocksMedicamentos[index2].stock);
                        setVisible(true);
                      }}
                      selectionMode="single"
                      dataKey="id"
                      header={header}
                      className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-demo"
                      style={{ fontSize: "small" }}
                      globalFilter={globalFilter}
                      emptyMessage="No hay datos."
                      paginator
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                      rows={10}
                      rowsPerPageOptions={[10, 20, 50]}
                      //paginatorLeft={paginatorLeft}
                      //paginatorRight={paginatorRight}
                    >
                      <Column
                        field="id"
                        header="ID"
                        body={idTemplate}
                        //sortable
                        style={{ display: "none" }}
                      ></Column>
                      <Column
                        field="sku"
                        header="SKU"
                        body={skuTemplate}
                        sortable
                        //style={{ width: "10%" }}
                      ></Column>
                      <Column
                        field="nombre"
                        header="Nombre"
                        body={nombreTemplate}
                        sortable
                        //style={{ width: "25%" }}
                      ></Column>
                      <Column
                        field="cantidad"
                        header="Consumido"
                        body={cantidadTemplate}
                        sortable
                        //style={{ width: "7%" }}
                      ></Column>
                      <Column
                        field="stock"
                        header="Stock"
                        body={stockTemplate}
                        sortable
                        //style={{ width: "7%" }}
                      ></Column>
                      <Column
                        field="reponer"
                        header="Reponer"
                        body={reponerTemplate}
                        sortable
                        //style={{ width: "7%" }}
                      ></Column>
                    </DataTable>
                  </div>
                </div>
              </Grid>
              <Dialog
                header={renderHeader()}
                visible={visible}
                closable={false}
                //onHide={onHide}
                footer={renderFooter()}
                breakpoints={{ "960px": "75vw" }}
                style={{ width: "50vw", paddingBottom: "0" }}
                position="center"
              >
                <Grid container spacing={3} style={{ marginTop: "1vw" }}>
                  {selectedRow ? (
                    <Grid item xs={6} md={3}>
                      <TextField
                        value={consumoMedicamento}
                        id="cantidad"
                        label="Cantidad"
                        type="number"
                        fullWidth
                        InputLabelProps={{
                          shrink: true,
                        }}
                        onChange={(e) => {
                          if (e.target.value) {
                            if (e.target.value && e.target.value < 0) {
                              e.target.value = 0;
                            }
                            if (e.target.value && e.target.value > stockTotal) {
                              e.target.value = stockTotal;

                              toast.current.show({
                                severity: "info",
                                summary: "Stocks",
                                detail: `La cantidad ha superado el stock de farmacia (${stockTotal}).`,
                                life: 3000,
                              });
                            }

                            guardarConsumoMedicamento(e.target.value);
                          } else {
                            guardarConsumoMedicamento(0);
                          }
                        }}
                      />
                    </Grid>
                  ) : null}
                </Grid>
              </Dialog>
            </Fragment>
          ) : (
            <Spinner />
          )}
          <Grid item xs={12} sm={12}></Grid>
        </Fragment>
      ) : null}
    </Fragment>
  );
}

/* class="MuiDataGrid-cell MuiDataGrid-cellLeft" */
